<template>
  <v-dialog v-model="show" width="50vw" scrollable persistent>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2"> Agregar peso </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="formWeight" lazy-validation>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="weight"
                  dense
                  outlined
                  type="number"
                  clearable
                  label="Introduce peso de bolsa (g)"
                  :rules="validationNumber()"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="red"
                block
                @click="closeModal"
                dark
                :disabled="isLoading"
                >Cancelar</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                block
                @click="confirmation"
                :loading="isLoading"
                >Aceptar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapMutations, mapState } from "vuex";
//validations
import { numberValidation } from "@/helpers/validations.js";
export default {
  data: () => ({
    loader: false,
    isLoading: false,
    weight: null,
  }),
  props: {
    value: Boolean,
    title: String,
  },
  computed: {
    ...mapState("lotes", ["formulationSelected"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapActions("order", ["setWeightFormulation"]),
    ...mapMutations("lotes", ["SET_FORMULATION"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    closeModal() {
      this.show = false;
    },
    validationNumber() {
      return numberValidation({ min: 1, required: true });
    },
    async confirmation() {
      // //emit desision
      // this.$emit("confirmation");
      // this.closeModal();
      if (this.$refs.formWeight.validate()) {
        try {
          this.isLoading = true;
          let payload = {
            weight: this.weight,
            formulationId: this.formulationSelected._id,
          };
          let response = await this.setWeightFormulation(payload);
          if (!response) throw response;
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Peso agregado",
            timeout: 3500,
          });
          this.SET_FORMULATION(response.formulationUpdated);
          this.$emit("fetchData");
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoading = false;
      }
    },
  },
};
</script>
